// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.


//= require jquery
//= require jquery_ujs
import Rails from "@rails/ujs"
Rails.start()


require("@rails/activestorage").start()
require("channels");

import 'bootstrap';
import './src/application.scss';

require("./number.js");

//= require echarts 

require("./main.js");
import "./orders_graph.js";

import "@fortawesome/fontawesome-free/js/all"

import "controllers"

// render flash message for 5 seconds
$(document).ready(function(){
  setTimeout(function(){
    $('#flash').fadeOut();
  }, 5000);
 })

import LocalTime from "local-time";
LocalTime.start();

require("trix")
require("@rails/actiontext")
import 'trix/dist/trix.css';

$(document).ready(function(){
  const form = document.querySelector('form');

  form.addEventListener('keypress', function (event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      form.submit();
    }
  });
})
